import { Maybe } from '@csp/csp-common-model';
import { matchRoutes, useLocation } from 'react-router-dom';
import { CspPath } from '../../../CspPath';

const matchPaths = (location: string, paths: CspPath[]): Maybe<CspPath> => {
  const matches = matchRoutes(
    paths.map(path => ({
      path,
    })),
    location,
  );

  return matches?.[0]?.pathname as Maybe<CspPath>;
};

export const useMatchPaths = (paths: CspPath[]): Maybe<CspPath> => {
  const location = useLocation();
  return matchPaths(location.pathname, paths);
};
